import { RefreshableBlock, refreshEvents } from './RefreshBlockContext';

export function useInvalidateRefreshableBlock() {
  return (type: RefreshableBlock) => {
    refreshEvents.emit(type);
  };
}
